<template>
    <h5
        class="mb-5 whitespace-pre-line text-pretty px-2 text-[1.0625rem] font-bold leading-[1.3] sm:px-5 sm:text-[1.125rem] lg:text-[1.25rem]"
    >
        <slot />
    </h5>
</template>
